var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('login-roll-back'),_c('router-view'),(_vm.shouldShowAddressPopup)?_c('set-address-profile',{on:{"success":_vm.onAddressSuccess},model:{value:(_vm.showAddressPopup),callback:function ($$v) {_vm.showAddressPopup=$$v},expression:"showAddressPopup"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }